import './style.scss';
import { CommunityData } from '../../server/types';
import AppCommunityResultProfile from '../app_communityResultProfile/AppCommunityResultProfile';

interface AppCommunitiesSearchResultRowProps {
	label: string,
	profiles: CommunityData[]
}

function AppCommunitiesSearchResultRow({label, profiles}: AppCommunitiesSearchResultRowProps) {
	return (
		<>
			<div className='app-community-result-row-label-wrap'>
				<img
					className='app-community-result-row-icon'
					src='/imgs/icons/community/icon-community-join.svg'
					alt='title arrow'
				/>
				<div className='app-community-result-row-label'>{label}</div>
			</div>
			<div className='app-community-result-row'>
				<div className="app-community-result-row-wrap">
					{profiles?.map((profile: CommunityData, index: number) => 
						<AppCommunityResultProfile
							profile={profile} 
							key={`profile-row${index}`}
						/>
					)}
				</div>
			</div>
		</>
	)
}

export default AppCommunitiesSearchResultRow
